import {postUtilUploadApi} from '../../utils/ApiHelper'

export default {
  methods: {
    $_setUploadImageFile (fileList, el, form) {
      const key = el.name
      const file = fileList[0]
      const fileSize = file.size / 1048576
      const message = '4MB未満のファイルを指定してください'
      const index = this.resultError.findIndex(e => e.errorItem === key && e.sizeError)

      if (fileSize < 4) {
        if (index > -1) {
          this.resultError[index].errorMessage = ''
        }
        this.$_setUploadImagePath(file, key, form)
      } else {
        this.form[key] = null
        this.file[key] = null
        form.reset();
        if (index > -1) {
          this.resultError[index].errorMessage = message
        } else {
          this.resultError.push({
            errorItem: key,
            errorMessage: message,
            sizeError: true
          })
        }
      }
    },
    $_setUploadImagePath (file, key, form) {
      this.isLoading = true
      postUtilUploadApi(file)
      .then(res => {
        const data = res.data
        const result = data.result
        if (result && result.errors) {
          // エラーは握り潰す
          form.reset();
        } else {
          this.form[key] = result.filePath
          this.file[key] = file
        }
        this.isLoading = false
      })
      .catch(() => {
        this.$router.push({name: 'rep320'})
      })
    },
    $_fileName(file) {
      return file ? file.name : ''
    }
  }
}
